<div *ngIf="isBrowser" class="unit">
  <app-onboarding-widget></app-onboarding-widget>
</div>
